export const environment = {
  production: false,
  baseUrl: 'https://ccapi.demisco.ai',
  authUrl: 'https://ccapi.demisco.ai/auth',
};
